'use client';

import { createContext, useContext, useState } from 'react';

type Props = {
  children?: React.ReactNode;
};

type CategoryContextType = {
  categoryKeys: string[];
  setCategoryKeys: (catKeys: string[]) => void;
};

export const CategoryContext = createContext<CategoryContextType>({
  categoryKeys: [],
  setCategoryKeys: () => {},
});

export const CategoryProvider: React.FC<Props> = ({ children }) => {
  const [categoryKeys, setCategoryKeys] = useState<string[]>([]);
  const ctx = { categoryKeys, setCategoryKeys };

  return <CategoryContext.Provider value={ctx}>{children}</CategoryContext.Provider>;
};

export const useCurrentCategory = () => {
  const ctx = useContext(CategoryContext);
  return ctx;
};
